import React from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Switch } from "./ui/switch";
import { Sparkles } from "lucide-react";

export const CTAControlPanel = ({
  ctaText,
  setCtaText,
  offer,
  setOffer,
  autoCTA,
  setAutoCTA,
  offerPlaceholder = "The Nomadic Wealth Academy",
  title = "CTA Control Panel",
  keywordPlaceholder = "e.g. GO  ·  one word only",
  keywordHelp = (
    <>
      One word. AI wraps it in a comment-driven CTA like:{" "}
      <span className="text-zinc-300">
        &ldquo;Comment <b>{"{KEYWORD}"}</b> and I&apos;ll send you my FREE Best-Selling Book.&rdquo;
      </span>{" "}
      Leave blank to fall back to a link-in-bio CTA.
    </>
  ),
}) => {
  // Coerce whatever the user types into a single uppercase word (one word only).
  const handleKeywordChange = (raw) => {
    const first = (raw || "").trim().split(/\s+/)[0] || "";
    // Strip anything that isn't a letter/number/underscore/hyphen, then uppercase.
    const clean = first.replace(/[^\p{L}\p{N}_-]/gu, "").toUpperCase();
    setCtaText(clean);
  };
  return (
    <div
      className="rounded-2xl border border-white/10 bg-zinc-900/60 p-5 sm:p-6"
      data-testid="cta-control-panel"
    >
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2">
          <Sparkles className="h-3.5 w-3.5 text-amber-400" strokeWidth={1.8} />
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400">
            {title}
          </h3>
        </div>
        <div className="flex items-center gap-2">
          <Label
            htmlFor="auto-cta"
            className="text-[11px] font-bold uppercase tracking-[0.2em] text-zinc-500"
          >
            Auto CTA
          </Label>
          <Switch
            id="auto-cta"
            checked={autoCTA}
            onCheckedChange={setAutoCTA}
            data-testid="auto-cta-switch"
            className="data-[state=checked]:bg-amber-500"
          />
        </div>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <Label className="text-[11px] font-bold uppercase tracking-[0.2em] text-zinc-500">
            CTA Keyword
          </Label>
          <Input
            placeholder={keywordPlaceholder}
            value={ctaText}
            onChange={(e) => handleKeywordChange(e.target.value)}
            data-testid="cta-keyword-input"
            maxLength={24}
            className="h-11 bg-zinc-950 border-zinc-800 text-white placeholder:text-zinc-600 focus:border-amber-500 uppercase tracking-[0.08em]"
          />
          <p className="text-[11px] text-zinc-500">{keywordHelp}</p>
        </div>

        <div className="space-y-2">
          <Label className="text-[11px] font-bold uppercase tracking-[0.2em] text-zinc-500">
            What are you promoting?
          </Label>
          <Input
            placeholder={offerPlaceholder}
            value={offer}
            onChange={(e) => setOffer(e.target.value)}
            data-testid="cta-offer-input"
            className="h-11 bg-zinc-950 border-zinc-800 text-white placeholder:text-zinc-600 focus:border-amber-500"
          />
        </div>
      </div>
    </div>
  );
};

export default CTAControlPanel;
